    <!-- =========================================================================================
    File Name: SettingsGeneral.vue
    Description: Change Information in Settings page
========================================================================================== -->
<template>
  <vx-card no-shadow>
    <div class="mb-base">
      <feather-icon icon="EditIcon" class="p-3 inline-flex rounded-full text-danger" :style="{background: `rgba(var(--vs-danger),.15)`}"></feather-icon>
      <span class="text-3xl text-danger mb-base ml-4">{{$t('ChangeInformation')}}</span>
    </div>
    <br />
    <!-- Info -->
    <vs-input  class="w-full" :label-placeholder="$t('ADMIN_NAME')" v-model="adminName" name="adminName" v-validate="{ max:30, alpha_spaces: true }" maxlength="31"></vs-input>
    <span class="text-danger text-sm mb-base" v-show="errors.has('adminName')">{{ errors.first('adminName') }}</span>

    <vs-input class="w-full mt-8" :label-placeholder="$t('EMAIL')" v-model="adminEmail" name="email"  v-validate="{ max:50, required: true, email:true }" maxlength="51" ></vs-input>
    <span class="text-danger text-sm mb-base" v-show="errors.has('email')">{{ errors.first('email') }}</span>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-4 mt-2" @click="saveInfo" :disabled="!isFormValid" >{{$t('SUBMIT')}}</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning" @click="resetInfo">{{this.$t('RESET')}}</vs-button>
    </div>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      adminName: '',
      adminEmail: ''
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    isFormValid() {
      return !this.errors.any()
    }
  },
  created() {
    let adminId = this.$store.state.AppActiveUser.userId
    this.$vs.loading()
    this.$store.dispatch("dataAdmin/fetchLoginAdminInformation", adminId).then(() =>{
      this.adminName = this.$store.state.dataAdmin.loginAdminInfo.name
      this.adminEmail = this.$store.state.dataAdmin.loginAdminInfo.email
      this.$vs.loading.close()
    })
  },
  methods: {
    checkDifferent(){

      let infoName = this.$store.state.dataAdmin.loginAdminInfo.name
      let infoEmail = this.$store.state.dataAdmin.loginAdminInfo.email

      if(this.adminName === infoName && this.adminEmail === infoEmail){
        this.errorAlert(this.$t("ERROR"), this.$t("NO_DIFFERENT_DATA"))
        return false
      }
        return true
    },
    saveInfo(){

      if(!this.checkDifferent()) return

      this.$vs.loading()

      const admin = {
              adminId : this.activeUserInfo.userId,
              name: this.adminName,
              email: this.adminEmail
      }

      this.$store.dispatch("dataAdmin/updateLoginAdminInformation", admin)
      .then(() => {
          this.$store.dispatch("dataAdmin/fetchLoginAdminInformation", admin.adminId)
          this.$vs.loading.close()
          this.successAlert(this.$t("SUCCESS"),this.$t("CHANGE_INFORMATION_SUCCESS"))
          
      })
      .catch(error => { 
          this.errorAlert(this.$t("ERROR"), error.message)
          this.$vs.loading.close()
      })
    },
    resetInfo(){
      this.adminName = this.$store.state.dataAdmin.loginAdminInfo.name
      this.adminEmail = this.$store.state.dataAdmin.loginAdminInfo.email
    }
  },
}
</script>
